@import (reference) '../../../../constants/spacing.module.less';

.expander-section {
  border-top: none;
  border-right: none;
  border-left: none;
  border-radius: @space-0;
}

.expander-content-order-items {
  padding: @space-0;
}

.expander-header-order-items {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.items-count {
  color: var(--grey-600);
}
